import { extendTheme } from '@chakra-ui/react'

const colors = {
  primary: {
    50: '#fff1e4',
    100: '#eed9c2',
    200: '#e0bf9f',
    300: '#d2a679',
    400: '#c58c54',
    500: '#ac733c',
    600: '#86592d',
    700: '#60401f',
    800: '#3b2611',
    900: '#180c00',
  },
}

const customTheme = extendTheme({ colors })

export default customTheme
